import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

import { RouteReloadService } from './route-reload.service';

/**
 * Пересоздать компоненты маршрута при явной навигации на ТЕКУЩИЙ URL —
 * но ТОЛЬКО когда пересоздание запрошено (RouteReloadService.request()).
 *
 * Story 99.28: cabinet/org-switch навигируют на тот же URL, чтобы перезапросить
 * данные с новым X-Cabinet/Org-ID → им нужно пересоздание компонента. Обычный же
 * повторный клик по активному пункту меню флаг не взводит → компонент
 * переиспользуется (нет тихой потери состояния формы, review P1 blast-radius).
 */
@Injectable()
export class SameUrlRouteReuseStrategy extends BaseRouteReuseStrategy {
  private readonly reload = inject(RouteReloadService);

  override shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    current: ActivatedRouteSnapshot
  ): boolean {
    if (this.fullUrl(future.root) === this.fullUrl(current.root)) {
      // Пересоздаём только если это запрошено (cabinet/org-switch); иначе — reuse.
      // peek (не сброс): стратегия зовётся по разу на каждый уровень маршрута.
      return !this.reload.pending();
    }

    return super.shouldReuseRoute(future, current);
  }

  private fullUrl(root: ActivatedRouteSnapshot): string {
    const segments: string[] = [];
    let route: ActivatedRouteSnapshot | null = root;

    while (route) {
      segments.push(...route.url.map(segment => segment.path));
      route = route.children.find(child => child.outlet === 'primary') ?? null;
    }

    const query = Object.keys(root.queryParams)
      .sort()
      .map(key => `${key}=${JSON.stringify(root.queryParams[key])}`)
      .join('&');

    return `/${segments.join('/')}?${query}#${root.fragment ?? ''}`;
  }
}
